import { render, staticRenderFns } from "./writeCardList.vue?vue&type=template&id=2670c7dd&scoped=true&"
import script from "./writeCardList.vue?vue&type=script&lang=js&"
export * from "./writeCardList.vue?vue&type=script&lang=js&"
import style0 from "./writeCardList.vue?vue&type=style&index=0&id=2670c7dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670c7dd",
  null
  
)

export default component.exports